import LetterPhaseChips from './components/LetterPhaseChips';

const LetterContainer = ({ showPhaseChips = true, topSlot, fullWidth = false, children }) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-neutral-25">
      {topSlot}
      {showPhaseChips && <LetterPhaseChips />}
      <div className="flex min-h-0 w-full flex-1 flex-col items-center overflow-y-auto overflow-x-hidden">
        <div
          className={`flex w-full flex-1 flex-col bg-white ${fullWidth ? '' : 'max-w-[720px]'}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default LetterContainer;
